import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "最多添加100个推荐产品", -1);

const _hoisted_2 = {
  class: "base_main_margin_top"
};
const _hoisted_3 = {
  class: "add_layout"
};
import { ref } from "vue";
import DynamicParams from "@com/DynamicParams.vue";
import ChooseProduct from "@com/marketing/ChooseProduct.vue";
import $ from "@util/base";
import { $msg, $box } from "@ui/msg";
import api from "@api/homepage";
const typeName = "recommend";
export default {
  __name: 'RecommendConfigure',

  setup(__props) {
    const data = ref([]);
    const recommendParams = ref(null);
    const modifyId = ref(null);
    let type = "add";
    const typeOptions = {
      1025001: {
        val: "goods",
        title: "商品"
      },
      1025002: {
        val: "travel",
        title: "旅行"
      },
      1025004: {
        val: "hotel",
        title: "酒店"
      }
    };

    function addRecommend(val) {
      type = "add";

      if (recommendParams.value.getValue().length < 100) {
        openChooseProduct(val);
      } else {
        $msg.error("最多添加100个");
      }
    }

    function delRecommend(index) {
      let data = recommendParams.value.getValue()[index];
      $box.open("删除确认", "是否删除", () => {
        api.del(typeName, data.id, () => {
          $msg.succ("删除成功");
          getData();
        });
      });
    }

    function modifyRecommend(index) {
      type = "modify";
      let data = recommendParams.value.getValue()[index];
      modifyId.value = data.id;
      openChooseProduct(typeOptions[data.recommendType].val);
    }

    function sortRecommend(data) {
      let idList = data.map(e => {
        return e.id;
      });
      api.sort(typeName, idList.reverse(), () => {
        $msg.succ("排序修改成功");
        getData();
      });
    }

    const chooseProductRef = ref(null);

    function openChooseProduct(val) {
      chooseProductRef.value.show(val);
    }

    const recommendType = {
      goods: "1025001",
      travel: "1025002",
      hotel: "1025004"
    };

    function chooseProduct(data) {
      let form = {};
      form.recommendType = recommendType[data.type];
      form.recommendItem = data.code;
      $.handleCRU(type, {
        add: () => {
          addData(form);
        },
        modify: () => {
          form.id = modifyId.value;
          modifyData(form);
        }
      });
    }

    function addData(form) {
      api.add(typeName, form, () => {
        $msg.succ("新增成功");
        getData();
      });
    }

    function modifyData(form) {
      api.update(typeName, form, () => {
        $msg.succ("修改成功");
        getData();
      });
    }

    getData();

    function getData() {
      api.list(typeName, val => {
        data.value = val.list;
      });
    }

    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_DynamicParams2 = _resolveComponent("DynamicParams2");

      const _component_el_main = _resolveComponent("el-main");

      const _directive_auth = _resolveDirective("auth");

      return _openBlock(), _createBlock(_component_el_main, {
        class: "base_main_content"
      }, {
        default: _withCtx(() => [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createVNode(_component_DynamicParams2, {
          ref_key: "recommendParams",
          ref: recommendParams,
          showDefault: false,
          noAdd: true,
          customDel: true,
          customMove: true,
          operation: {
            modify: true,
            move: true,
            del: true
          },
          data: data.value,
          onDelete: delRecommend,
          onModify: modifyRecommend,
          onMove: sortRecommend
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "产品名称",
            prop: "recommendItemName",
            align: "center"
          }), _createVNode(_component_el_table_column, {
            label: "产品类型",
            align: "center",
            width: "150px"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(typeOptions[scope.row.recommendType].title), 1)]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"]), _createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createElementBlock("div", {
          onClick: _cache[0] || (_cache[0] = $event => addRecommend('goods')),
          class: "dashed_but"
        }, [_createTextVNode("添加商品")])), [[_directive_auth, _ctx.getCurCode('ADDPRODUCT')]]), _withDirectives((_openBlock(), _createElementBlock("div", {
          onClick: _cache[1] || (_cache[1] = $event => addRecommend('travel')),
          class: "dashed_but"
        }, [_createTextVNode("添加旅游")])), [[_directive_auth, _ctx.getCurCode('ADDTRAVEL')]]), _withDirectives((_openBlock(), _createElementBlock("div", {
          onClick: _cache[2] || (_cache[2] = $event => addRecommend('hotel')),
          class: "dashed_but"
        }, [_createTextVNode("添加酒店")])), [[_directive_auth, _ctx.getCurCode('ADDHOTEL')]])])]), _createVNode(ChooseProduct, {
          ref_key: "chooseProductRef",
          ref: chooseProductRef,
          onChooseProduct: chooseProduct
        }, null, 512)]),
        _: 1
      });
    };
  }

};